import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import medidorgif from "../../../../assets/lottie/Medidor-peso.gif";
import logo2 from "../../../../assets/images/weighing/register/qr-registro movil.png";
import Menu from "../../../../components/layout/menu/index";
import check from "../../../../assets/images/weighing/medidor-check.png";
import ModalRegister from "../../../../components/shared/successRegisterModal/index";
import ModalSignature from "../../../../components/qr/modalSignature/index";
import { getVisits, updateVisitId } from "../../../../client/administration/list/index";
import { createEvent, getEvents, updateEventId} from "../../../../client/administration/event/index";
import Select from 'react-select';
import { getProducts } from "../../../../client/administration/products/index";
import axios from "axios";
import Programate from "../../../../components/layout/footer";
import { format } from 'date-fns'; 
import { es } from 'date-fns/locale';

const API_URL = "https://192.168.238.230:8000/api";
axios.defaults.withCredentials = true;

export default function Register() {
    const location = useLocation();
  //  const {eventData} = location.state || {};
   // console.log("Datos recibidos en detalle-ticket:", eventData);
   const navigate = useNavigate();





const { 
    qrData, 
    isSalida: isSalidaQR, 
    savedProduct, 
    savedWagonPlate, 
    savedBaggingCode, 
    savedContainer, 
    savedRemissionGuide 
} = location.state || {}; 

const [event, setEvent] = useState(null);
const [isSalida, setIsSalida] = useState(isSalidaQR || false);

 const visitaData = location.state?.visitaData || null;
const idVisita = qrData?.id_visita || visitaData?.idVisiTasa || null;

useEffect(() => {
    if (!qrData) {  // Solo busca en getEvents() si no hay datos del QR
        const fetchEvents = async () => {
            try {
                const response = await getEvents(); 
                
                if (!response?.data || !Array.isArray(response.data)) {
                    console.error("getEvents() no devolvió un array válido:", response);
                    return;
                }

                const foundEvent = response.data.find(e => e.ouputWeighting === null);
                setEvent(foundEvent);
                setIsSalida(Boolean(foundEvent));

            } catch (error) {
                console.error("Error al obtener eventos:", error);
            }
        };

        fetchEvents();
    }
}, [qrData]);


const [valorRecibido, setValorRecibido] = useState("00,000");
const [successMessage, setSuccessMessage] = useState(null); 
    const [loading, setLoading] = useState(false); // Estado para manejar el loading
    const [error, setError] = useState(null); // Estado para manejar errores
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const [isGifPlaying, setIsGifPlaying] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [showModalRegister, setShowModalRegister] = useState(false);
    const [selectedBalanza, setSelectedBalanza] = useState('');

    const openModal = () => setShowModalRegister(true);
    const closeModal = () => {
        setShowModalRegister(false);
       /* if (matchingEvent) {
            navigate("/detalle-ticket", { state: { eventData: matchingEvent } });
            console.log("match:", matchingEvent)
        }*/
    };

    const [showModalSignature, setShowModalSignature] = useState(false);
    const [signatureImage, setSignatureImage] = useState(null);

    const openModalSignature = () => setShowModalSignature(true);
    const closeModalSignature = () => setShowModalSignature(false);
    const [saveSuccessful, setSaveSuccessful] = useState(false);

    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);   
    
    const [localTime, setLocalTime] = useState("");

    const [observation, setObservation] = useState("");

    const [isChecked, setIsChecked] = useState(false);
    const [placaCarreta, setPlacaCarreta] = useState('0');
    useEffect(() => {
        if (!isChecked) {
            setPlacaCarreta('0'); // Asignar '0' si el checkbox está desmarcado
        }
    }, [isChecked]);

    const handleChangeCarreta = (e) => {
        const value = e.target.value;
        // Si el campo no está vacío o el usuario está escribiendo, actualizamos el valor
        if (isChecked) {
            setPlacaCarreta(value);
        }
    };

    const [isChecked2, setIsChecked2] = useState(false);
    const [numeroEnsaque, setNumeroEnsaque] = useState('0');
    useEffect(() => {
        if (!isChecked2) {
            setNumeroEnsaque('0'); // Asignar '0' si el checkbox está desmarcado
        }
    }, [isChecked2]);

    const handleChangeEnsaque = (e) => {
        const value = e.target.value;
        // Si el campo no está vacío o el usuario está escribiendo, actualizamos el valor
        if (isChecked2) {
            setNumeroEnsaque(value);
        }
    };

    const [isChecked3, setIsChecked3] = useState(false);
    const [numeroContenedor, setNumeroContenedor] = useState('XXXX');
    useEffect(() => {
        if (!isChecked3) {
            setNumeroContenedor('XXXX');
        }
    }, [isChecked3]);

    const handleChangeContenedor = (e) => {
        const value = e.target.value;
    
        if (isChecked3) {
          const formattedValue = formatInput(value);
          setNumeroContenedor(formattedValue);
        }
    };
    const formatInput = (value) => {
        // Solo permite letras (mayúsculas o minúsculas) y convierte a mayúsculas
        const allowedChars = value.replace(/[^a-zA-Z]/g, '').toUpperCase();
    
        // Limita la longitud a 4 caracteres
        const maxLength = 4;
        const truncatedValue = allowedChars.slice(0, maxLength);
    
        return truncatedValue;
    };
    //- SEGUNDO INPUT DE N° CONTENEDOR
    const [numeroContenedor2, setNumeroContenedor2] = useState('000000');
    useEffect(() => {
        if (!isChecked3) {
            setNumeroContenedor2('000000');
        }
    }, [isChecked3]);

    const handleChangeContenedor2 = (e) => {
        const value = e.target.value;
    
        if (isChecked3) {
          const formattedValue = formatInput2(value);
          setNumeroContenedor2(formattedValue);
        }
    };
    const formatInput2 = (value) => {
        const allowedChars = value.replace(/\D/g, '');
        const maxLength = 6;
        const truncatedValue = allowedChars.slice(0, maxLength);
        return truncatedValue;
    };

    const [numeroContenedor3, setNumeroContenedor3] = useState('0');
    useEffect(() => {
        if (!isChecked3) {
            setNumeroContenedor3('0');
        }
    }, [isChecked3]);

    const handleChangeContenedor3 = (e) => {
        const value = e.target.value;
    
        if (isChecked3) {
          const formattedValue = formatInput3(value);
          setNumeroContenedor3(formattedValue);
        }
    };
    const formatInput3 = (value) => {
        const allowedChars = value.replace(/\D/g, '');
        const maxLength = 1;
        const truncatedValue = allowedChars.slice(0, maxLength);
        return truncatedValue;
    };
    
    const [isChecked4, setIsChecked4] = useState(false);
    const [guiaRemision, setGuiaRemision] = useState('00-0000000');
    useEffect(() => {
        if (!isChecked4) {
            setGuiaRemision('00-0000000');
        }
    }, [isChecked4]);

    const handleChangeGuia = (e) => {
        const value = e.target.value;
        const formattedValueGuia = formatInputGuia(value);
        if (isChecked4) {
            setGuiaRemision(formattedValueGuia);
        }
    };
    const formatInputGuia = (value) => {

        const allowedChars = value.replace(/[^a-zA-Z0-9-]/g, '');

        const maxLength = 9;
        const truncatedValue = allowedChars.slice(0, maxLength);

        let formatted = truncatedValue;

        if (formatted.length > 2 && formatted[2] !== '-') {
            formatted = `${formatted.slice(0, 2)}-${formatted.slice(2)}`;
        }

        return formatted;
    };

    useEffect(() => {
        const date = new Date();
        const options = { hour: '2-digit', minute: '2-digit', hour12: true };
        const formattedTime = date.toLocaleString('en-US', options);
        setLocalTime(formattedTime);
    }, []);

    const formatTime = (isoString) => {
        const date = new Date(isoString);
        const options = { hour: 'numeric', minute: 'numeric', hour12: true };
        return date.toLocaleString('en-US', options);
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await getProducts(); //  obtener los productos
                const productOptions = response.data.map(product => ({
                    value: product.id,
                    label: product.productName
                }));
                setProducts(productOptions);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
    }, []);

    const handleChange = (selectedOption) => {
        setSelectedProduct(selectedOption);
      //  console.log("Selected product:", selectedOption);
    };

    useEffect(() => {
        if (saveSuccessful) {
            openModal(); // Abrir el modal después de guardar
        }
    }, [saveSuccessful]);

    const valorRecibidoNumerico = parseFloat(valorRecibido); 
    

    const formatVisitDateRange = (startDateScheduled, finalDateScheduled) => {
        const startDate = new Date(startDateScheduled);
        const finalDate = new Date(finalDateScheduled);
    
        // Formatear las fechas
        const startDateFormatted = format(startDate, 'dd \'de\' MMMM hh:mm aaaa', { locale: es });
        const finalDateFormatted = format(finalDate, 'hh:mm aaaa', { locale: es });
    
        // Comparar las fechas
        if (startDate.toDateString() === finalDate.toDateString()) {
            // Si la visita termina el mismo día
            return `${startDateFormatted} a ${finalDateFormatted}`;
        } else {
            // Si termina en otra fecha
            const finalDateDayFormatted = format(finalDate, 'dd \'de\' MMMM', { locale: es });
            return `${startDateFormatted} a ${finalDateDayFormatted} ${finalDateFormatted}`;
        }
    };

    const handleSave = async () => {
        
        // Validar campos obligatorios
        if (!validarCamposObligatorios()) {
            setError("Por favor, complete todos los campos obligatorios.");
            return; // Detener el proceso si hay campos obligatorios vacíos
        }
        
        // Validar el código verificador (si aplica)
        if (isChecked3) {
            const codigoVerificadorCalculado = calcularCodigoVerificador(numeroContenedor, numeroContenedor2);
            const codigoVerificadorIngresado = parseInt(numeroContenedor3, 10);

            if (codigoVerificadorCalculado !== codigoVerificadorIngresado) {
                setError("El código verificador no es válido.");
                return; // Detener el proceso si el código verificador no es válido
            }
        }
        try {
            setLoading(true);
            setError(null);
            setSuccessMessage(null);

            const visitsResponse = await getVisits();
            const eventsResponse = await getEvents();
    
            if (visitsResponse.status === 200) {
                const visitsData = visitsResponse.data;
                const matchingVisit = visitsData.find(
                    (visit) => visit.idVisiTasa === parseInt(idVisita, 10)
                  );
    
                if (matchingVisit) {
                    const matchingEvent = eventsResponse.data.find(
                        (event) => event.visit.idVisiTasa === parseInt(idVisita, 10) &&
                            event.ouputWeighting === null
                    );
    
                    if (matchingEvent) {
                        // REGISTRO DE SALIDA
                        const date = new Date();
                        const localISODeparture = date
                            .toLocaleString("sv-SE", { timeZone: "UTC", hour12: false })
                            .replace(" ", "T");       
    
                        const updatedData = {
                            wagonPlate: matchingEvent.wagonPlate, 
                            baggingCode: matchingEvent.baggingCode,
                            container: matchingEvent.container, 

                            inputWeighting: matchingEvent.inputWeighting,
                            ouputWeighting: valorRecibido,
                          // ouputWeighting: 8000,
                            departureDate: localISODeparture,
                            departureSignatureFile: signatureImage ? await fetch(signatureImage).then(res => res.blob()) : null, // Convertir a blob, 
                            observationOfEntry: matchingEvent.observationOfEntry,
                            observationOfExit: observation,
                            idProduct: matchingEvent.idProduct,
                            idVisit: matchingEvent.idVisit,
                            idStand: matchingEvent.idStand,
                        };
    
                        const updateEventResponse = await updateEventId(
                            matchingEvent.id,
                            updatedData
                        );
                        console.log("Datos de salida enviados al servidor:", updatedData);

                        if (updateEventResponse.status === 200) {
                                setEvent(updateEventResponse.data);
                            setSuccessMessage("Datos de salida guardados exitosamente.");
                            setSaveSuccessful(true);
                        } else {
                             // Manejar errores específicos del servidor
                            const errorMessage = updateEventResponse.data?.message || "No se pudo actualizar los datos de salida.";
                        
                            setError(errorMessage);
                            console.log(errorMessage)
                            }
                        
    
                    } else {
                        // REGISTRO DE ENTRADA
                        const date = new Date();
                        const localISODate = date
                            .toLocaleString("sv-SE", { timeZone: "UTC", hour12: false })
                            .replace(" ", "T");
                        const container = `${numeroContenedor}${numeroContenedor2}${numeroContenedor3}`;
    
                        const eventData = {
                            inputWeighting: valorRecibido,
                         // inputWeighting: 1000,
                            dateOfEntry: localISODate,
                            signatureOfEntryFile: signatureImage ? await fetch(signatureImage).then(res => res.blob()) : null, // Convertir a blob
                            observationOfEntry: observation,
                            idVisit: matchingVisit.id,
                            idStand: 4,
                            idProduct: selectedProduct ? selectedProduct.value : null,
                            wagonPlate: placaCarreta, 
                            baggingCode: numeroEnsaque, 
                            container: container, 
                        };

                        console.log("Datos de entrada enviados al servidor:", eventData);
                        
                   
                        console.log("RemissionGuide:", guiaRemision);
                        const eventResponse = await createEvent(eventData);
    
                        if (eventResponse.status === 201) {
                            // Actualizar la visita con RemissionGuide
                                setEvent(eventResponse.data);
                            const updatedVisitaData = {
                                ...matchingVisit,
                                remissionGuide: guiaRemision,
                            };
    
                            const updateVisitResponse = await updateVisitId(
                                matchingVisit.id,
                                updatedVisitaData
                            );
                            console.log("Respuesta del servidor al actualizar la visita:", updateVisitResponse);
    
                            if (updateVisitResponse.status === 200) {
                                setSuccessMessage(
                                    "Datos guardados y visita actualizada exitosamente."
                                );
                                setSaveSuccessful(true);
                            } else {
                                // Manejar errores al actualizar la visita
                            const errorMessage = updateVisitResponse.data?.message || "No se pudo actualizar la visita.";
                            setError(errorMessage);
                            console.error(errorMessage)
                            }
                        } else {
                            const errorMessage = eventResponse.data?.message || "No se pudo guardar los datos. Intenta nuevamente.";
                      
                        setError(errorMessage);
                        }
                    }
                } else {
                    setError("El ID de visita no coincide.");
                }
            } else {
                setError("No se pudo obtener los datos de la visita.");
            }
        } catch (error) {
            console.error("Error al guardar los datos:", error.response?.data || error.message);
            console.error("Errores de validación:", error.response?.data?.errors); // Inspeccionar errores de validación
            setError(`Error al guardar los datos: ${error.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleRedirectToTicket = async () => {
        if (event) { // Verifica que event no sea null o undefined
            try {
                // Obtener los datos de la visita asociada al evento
                const visitsResponse = await getVisits();
                const matchingVisit = visitsResponse.data.find(
                    (visit) => visit.id === event.idVisit
                );
    
                // Redirigir a la página de detalles del ticket con los datos del evento y la visita
                navigate("/detalle-ticket", {
                    state: {
                        eventData: event, // Datos del evento
                        visitaData: matchingVisit, // Datos de la visita
                    },
                });
            } catch (error) {
                console.error("Error al obtener los datos de la visita:", error);
                // Redirigir solo con los datos del evento si no se pueden obtener los datos de la visita
                navigate("/detalle-ticket", { state: { eventData: event } });
            }
        } else {
            console.error("No se pudo redirigir: event es null o undefined");
        }
    };
    

    const saveToLocalStorage = (data) => {
        const pendingData = JSON.parse(localStorage.getItem('pendingData')) || [];
        pendingData.push(data);
        localStorage.setItem('pendingData', JSON.stringify(pendingData));
    };

    useEffect(() => {
        const sendPendingData = async () => {
            const pendingData = JSON.parse(localStorage.getItem('pendingData')) || [];
            if (pendingData.length > 0 && navigator.onLine) {
                try {
                    for (const item of pendingData) {
                        console.log("Enviando datos pendientes:", item); // Depuración
                        if (item.type === 'salida') {
                            await updateEventId(item.data.id, item.data);
                        } else if (item.type === 'entrada') {
                            await createEvent(item.data);
                        }
                    }
                    localStorage.removeItem('pendingData'); // Limpiar el localStorage después de enviar
                } catch (error) {
                    console.error("Error al enviar datos pendientes:", error);
                    console.error("Detalles del error:", error.response?.data); // Depuración
                }
            }
        };
    
        // Enviar datos pendientes cuando se detecta conexión a internet
        const handleOnlineStatus = () => {
            if (navigator.onLine) {
                sendPendingData();
            }
        };
    
        // Escuchar el evento 'online' para detectar cuando el usuario vuelve a estar en línea
        window.addEventListener('online', handleOnlineStatus);
    
        // Limpiar el listener al desmontar el componente
        return () => {
            window.removeEventListener('online', handleOnlineStatus);
        };
    }, []);
    
    const handleSaveSignature = (signatureDataURL) => {
        const base64Data = signatureDataURL.startsWith('data:image/png;base64,') 
        ? signatureDataURL 
        : `data:image/png;base64,${signatureDataURL}`;
    
    setSignatureImage(base64Data); 
    console.log("Firma guardada en base64:", base64Data); 
    };
        
    const startProcess = () => {
        const eventSource = new EventSource(`${API_URL}/start`);
        eventSource.onmessage = (event) => {
            console.log("Dato START recibido:", event.data);
        };
        eventSource.onerror = (error) => {
            console.error("Error en el start:", error);
            eventSource.close();
        };
        return () => eventSource.close();
    };
    const streamProcess = () => {
        const eventSource = new EventSource(`${API_URL}/stream`);
        eventSource.onmessage = (event) => {
            console.log("Dato STREAM recibido:", event.data);
            setValorRecibido(event.data);
        };
        eventSource.onerror = (error) => {
            console.error("Error en el stream:", error);
            eventSource.close();
        };
        return () => eventSource.close();
    };

    const stopProcess = () => {
        const eventSource = new EventSource(`${API_URL}/stop`);
        eventSource.onmessage = (event) => {
            console.log("Dato recibido:", event.data);
            setValorRecibido(event.data);
        };
        eventSource.onerror = (error) => {
            console.error("Error en el stop:", error);
            eventSource.close();
        };
        return () => eventSource.close();
    };

    const handleGifClick = () => {
        if (isGifPlaying) {
            // Si el GIF ya está en reproducción, lo detenemos y ejecutamos stopProcess.
            setIsGifPlaying(false);
            stopProcess();
            setIsCompleted(true); // Marcar como completado cuando se detiene.
        } else {
            // Si el GIF no está en reproducción, lo iniciamos y ejecutamos streamProcess.
            setIsGifPlaying(true);
            streamProcess();
        }
    };
  
    const handleSignatureClick = () => {
        openModalSignature();      
    };

    //funcion para validar el codigo verificador del n° contenedor
    const calcularCodigoVerificador = (numeroContenedor, numeroContenedor2) => {
        // Mapeo de letras a valores numéricos
        const valoresLetras = {
            A: 10, B: 12, C: 13, D: 14, E: 15, F: 16, G: 17, H: 18, I: 19, J: 20,
            K: 21, L: 23, M: 24, N: 25, O: 26, P: 27, Q: 28, R: 29, S: 30, T: 31,
            U: 32, V: 34, W: 35, X: 36, Y: 37, Z: 38
        };
    
        // Multiplicadores para cada posición
        const multiplicadores = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512];
    
        // Convertir el número de contenedor a un array de caracteres
        const contenedorCompleto = `${numeroContenedor}${numeroContenedor2}`.toUpperCase();
        const caracteres = contenedorCompleto.split('');
    
        // Calcular la suma total
        let sumaTotal = 0;
        for (let i = 0; i < caracteres.length; i++) {
            const caracter = caracteres[i];
            const valor = valoresLetras[caracter] || parseInt(caracter, 10); // Si es un número, se convierte a entero
            const multiplicador = multiplicadores[i];
            sumaTotal += valor * multiplicador;
        }
    
        // Calcular el residuo de la división entre 11
        const residuo = sumaTotal % 11;
        return residuo;
    };

    //VALIDACION EN INPUTS
    const [estiloContenedor, setEstiloContenedor] = useState({
        numeroContenedor: "", // Estilo inicial vacío
        numeroContenedor2: "",
        numeroContenedor3: "",
    });
    const validarCodigoVerificador = () => {
        const codigoVerificadorCalculado = calcularCodigoVerificador(numeroContenedor, numeroContenedor2);
        const codigoVerificadorIngresado = parseInt(numeroContenedor3, 10);
    
        if (codigoVerificadorCalculado === codigoVerificadorIngresado) {
            // Código válido: pintar de verde
            setEstiloContenedor({
                numeroContenedor: " border-green",
                numeroContenedor2: " border-green",
                numeroContenedor3: " border-green",
            });
            setIsButtonDisabled(false); // Habilitar el botón
        } else {
            // Código inválido: pintar de rojo
            setEstiloContenedor({
                numeroContenedor: " border-red",
                numeroContenedor2: "border-red",
                numeroContenedor3: "border-red",
            });
            setIsButtonDisabled(true); // Deshabilitar el botón
        }
    };
    useEffect(() => {
        if (numeroContenedor && numeroContenedor2 && numeroContenedor3) {
            validarCodigoVerificador();
        }
    }, [numeroContenedor, numeroContenedor2, numeroContenedor3]);

    useEffect(() => {
        if (!isChecked3) {
            setNumeroContenedor("0000");
            setNumeroContenedor2("000000");
            setNumeroContenedor3("0");
            setEstiloContenedor({
                numeroContenedor: "",
                numeroContenedor2: "",
                numeroContenedor3: "",
            });
            setIsButtonDisabled(false);
        }
    }, [isChecked3]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [mostrarAlertas, setMostrarAlertas] = useState({
        selectedProduct: false, // Inicialmente no mostrar alerta
        signatureImage: false,  // Inicialmente no mostrar alerta
    });
    
    const validarCamposObligatorios = () => {
        let camposValidos = true;
    
        const nuevasAlertas = {
            selectedProduct: false,
            signatureImage: false,
        };
    
        //Valida si se seleccionó el producto solo si es entrada
        if (!isSalida && !selectedProduct) {
            nuevasAlertas.selectedProduct = true;
            camposValidos = false;
        }

        if (!signatureImage) {
            nuevasAlertas.signatureImage = true;
            camposValidos = false;
        }
    
        setMostrarAlertas(nuevasAlertas);
    
        return camposValidos;
    };
    
    useEffect(() => {
        if (signatureImage && (isSalida || selectedProduct)) {
          setMostrarAlertas({
            selectedProduct: false,
            signatureImage: false,
          });
        }
    }, [selectedProduct, signatureImage, isSalida]);

    const handleBalanzaChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedBalanza(selectedValue);
        startProcess(); 
    };

    const isFormValid = () => {
        return validarCamposObligatorios(); // Asumiendo que esta función ya valida todos los campos necesarios
    };

    return (
        <div className='flex w-full min-h-screen'>
            <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
            <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[200px] sm:ml-[0] md:ml-[0]" : "ml-0"} w-[87%]`}>       
                <div className="flex flex-col justify-between min-h-screen">
                    <div className="z-10 relative flex flex-col md:pt-32 pt-24 items-center justify-center px-[5%] bg-white py-16 lg:px-[20%]">
                        <h1 className="text-[32px] font-itcbold text-blue text-center mb-4">
                            {isSalida ? "REGISTRO DE SALIDA" : "REGISTRO DE LLEGADA"}
                        </h1>
                        <div className="flex mb-4">
                            <select 
                                className="text-start text-[20px] font-itcmedium text-blue" 
                                value={selectedBalanza} 
                                onChange={handleBalanzaChange}
                            >
                                <option value="">Selecciona una balanza</option>
                                <option value="balanza1">Balanza 1</option>
                                <option value="balanza2">Balanza 2</option>
                                <option value="balanza3">Balanza 3</option>
                            </select>
                        </div>
                        
                        <div className="rounded-[20px] sm:px-5 sm:p-4 p-3 flex gap-4  flex-col md:flex-row justify-center items-center w-full h-auto bg-gradient-to-r from-[#FFC700] to-[#FF9501]">
                            <div className="flex items-center justify-around w-full gap-1 md:w-1/2">
                                {isCompleted ? (
                                <img
                                    src={check}
                                    alt="Check final"
                                    className="drop-shadow-card w-[40.8px] h-[40.8px]"
                                />
                                ) : (
                                <div className="drop-shadow-card w-[61px] h-[93px] rounded-[10px] bg-white flex flex-col items-center p-0.5 justify-center">
                                    <div className="bg-[#007696] w-[51px] h-[51px] rounded-full flex justify-center items-center">
                                        <div className="bg-white bg-opacity-70 w-[44.59px] h-[44.59px] rounded-full flex items-center justify-center">
                                            <img
                                                src={medidorgif}
                                                alt="GIF de pesado"
                                                className="drop-shadow-card w-[40.8px] h-[40.8px] cursor-pointer"
                                                onClick={handleGifClick}
                                            />
                                        </div>
                                    </div>
                                    <p className="text-[#017190] font-itcdemi text-xs text-center">
                                        Empezar a pesar
                                    </p>
                                </div>
                                )}
                                <img src={logo2} alt="QR"/>
                                <div className="flex flex-col items-center justify-center gap-1">
                                    <p className="text-gree-light md:text-[28px] text-2xl font-itcdemi">Pesado</p>
                                    <p className="text-sm sm:text-base text-gree-light font-itcmedium">Codigo QR</p>
                                    <p className="text-sm text-white sm:text-base font-itcmedium">N°8485482</p>
                                </div>
                            </div>
                    
                            <div className="flex items-center justify-center w-full md:w-1/2">
                                <p className="text-5xl text-white md:text-4xl font-itcbold"> {valorRecibido} Kg.</p>
                            </div>
                        </div>
                        <div className="w-full px-[2%] gap-4 pt-6 flex flex-col items-center justify-between">
                            <p className="text-blue text-[32px] font-itcbold mb-2">Información</p>
                            <div className="flex flex-col items-center justify-between w-full mt-2 space-y-4">
                            {qrData?.nombre_conductor || visitaData?.driverName ?(
                            <>
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                    <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Nombre del conductor</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                    <p className="text-gray md:text-[20px] text-[18px] font-itcbook">  {qrData?.nombre_conductor || visitaData?.driverName || "-"}</p>
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">DNI</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        <p className="text-gray md:text-[20px] text-[18px] font-itcbook">  {qrData?.dni || visitaData?.dni || "-"}</p>
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Producto</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        {isSalida  ? (
                                            <p className="text-gray md:text-[20px] text-[18px] font-itcbook ">
                                                            {savedProduct || event?.product?.productName || "-"}

                                            </p>
                                        ) : (
                                            <p className="flex items-center gap-2 text-gray md:text-[20px] text-[18px] font-itcbook ">
                                            <Select
                                                className="w-11/12 text-gray border-gray focus:ring-gray"
                                                value={selectedProduct}
                                                onChange={handleChange}
                                                options={products}
                                                placeholder="Seleccione..."
                                                isSearchable
                                            />
                                            {mostrarAlertas.selectedProduct && (
                                                <span className="text-xl text-red ">⚠️</span> // Ícono de alerta
                                            )}
                                            </p>
                                        )
                                        }
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Placa</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        <p className="text-gray md:text-[20px] text-[18px] font-itcbook">{qrData?.placa_vehiculo || visitaData?.plate || "-"}</p>
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Tipo de vehículo</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        <p className="text-gray md:text-[20px] text-[18px] font-itcbook">{qrData?.tipo_vehiculo || visitaData?.typeVehicle  || "-"}</p>
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Empresa</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        <p className="text-gray md:text-[20px] text-[18px] font-itcbook">{qrData?.empresa || visitaData?.companyName || "-"}</p>
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Fecha agendada</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        <p className="text-gray md:text-[20px] text-[18px] font-itcbook">
                                        {qrData?.hora_agendada ? formatTime(qrData.hora_agendada) : formatVisitDateRange(visitaData?.startDateScheduled, visitaData?.finalDateScheduled) || "-"}
                                        </p>
                                    </div>
                                </div>
    
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">{isSalida ? "Hora de salida" : "Hora de llegada"}</p>
                                    </div>
                                    <div className="w-[50%] justify-start ">
                                        <p className="text-gray md:text-[20px] text-[18px] font-itcbook">{localTime}</p>
                                    </div>
                                </div>
    
                                {isSalida  ? (
                                    <>
                                    <div className="flex items-center justify-between w-full gap-3">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Placa carreta</p>
                                        </div>
                                        <div className="w-[50%] justify-start">
                                            <p className="text-gray md:text-[20px] text-[18px] font-itcbook ">
                                            {(savedWagonPlate !== "0" && savedWagonPlate) || (event?.wagonPlate !== "0" && event?.wagonPlate) || "-"}
                                            </p>       
                                        </div>                                                             
                                    </div>

                                    <div className="flex items-center justify-between w-full gap-3">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Número ensaque</p>
                                        </div>
                                        <div className="w-[50%] justify-start">
                                            <p className="text-gray md:text-[20px] text-[18px] font-itcbook ">
                                            {(savedBaggingCode !== "0" && savedBaggingCode) || (event?.baggingCode !== "0" && event?.baggingCode) || "-"}
                                            </p>       
                                        </div>                                                             
                                    </div>


                                    <div className="flex items-center justify-between w-full gap-3">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">N° Contenedor</p>
                                        </div>
                                        <div className="w-[50%] justify-start">
                                            <p className="text-gray md:text-[20px] text-[18px] font-itcbook ">
                                            {(savedContainer !== "00000000000" && savedContainer) || (event?.container !== "00000000000" && event?.container) || "-"}
                                            </p>       
                                        </div>                                                             
                                    </div>

                                    <div className="flex items-center justify-between w-full gap-3">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Guía de Remisión</p>
                                        </div>
                                        <div className="w-[50%] justify-start">
                                            <p className="text-gray md:text-[20px] text-[18px] font-itcbook ">
                                            {(savedRemissionGuide !== "00-0000000" && savedRemissionGuide) || (event?.visit?.remissionGuide !== "00-0000000" && event?.visit?.remissionGuide) || "-"}
                                            </p>       
                                        </div>                                                             
                                    </div>
                                    </>

                                ):(
                                    <>
                                    <div className="grid grid-cols-2 gap-4 py-6 md:flex md:space-x-7 font-itcmedium">

                                        <div className="flex items-center space-x-1 ">
                                                <input
                                                    type="checkbox"
                                                    id="enableInput"
                                                    checked={isChecked}
                                                    onChange={() => setIsChecked(!isChecked)} // Cambiar el estado del checkbox
                                                    className="w-5 h-5 border-blue"
                                                />
                                                <label htmlFor="enableInput" className="text-blue md:text-[16px] text-[14px] leading-tight">Placa Carreta</label>
                                        </div>

                                        <div className="flex items-center space-x-1">
                                            <input
                                                type="checkbox"
                                                id="enableInput2"
                                                checked={isChecked2}
                                                onChange={() => setIsChecked2(!isChecked2)} // Cambiar el estado del checkbox
                                                className="w-5 h-5 border-blue"
                                            />
                                             <label htmlFor="enableInput2" className="text-blue md:text-[16px] text-[14px] leading-tight">Número Ensaque</label>
                                    </div>
    
                                    <div className="flex items-center space-x-1">
                                            <input
                                                type="checkbox"
                                                id="enableInput3"
                                                checked={isChecked3}
                                                onChange={() => setIsChecked3(!isChecked3)} // Cambiar el estado del checkbox
                                                className="w-5 h-5 border-blue "
                                            />
                                             <label htmlFor="enableInput3" className="text-blue md:text-[16px] text-[14px] leading-tight">N° Contenedor</label>
                                    </div>
    
                                    <div className="flex items-center space-x-1">
                                            <input
                                                type="checkbox"
                                                id="enableInput4"
                                                checked={isChecked4}
                                                onChange={() => setIsChecked4(!isChecked4)} // Cambiar el estado del checkbox
                                                className="w-5 h-5 border-blue"
                                            />
                                             <label htmlFor="enableInput4" className="text-blue md:text-[16px] text-[14px] leading-tight">Guía de Remisión</label>
                                    </div>
                                    </div>
                                    </>
                                )}

    
                                {isChecked && (
                                    <div className="flex flex-col justify-between w-full gap-3 md:items-center md:flex-row">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Placa Carreta</p>
                                        </div>
                                        <div className="flex md:w-[50%] w-full justify-between">
                                            <input
                                                id="placaCarreta"
                                                type= "text"
                                                className="text-gray p-2 md:text-[18px] text-[16px] focus:outline-none font-itcbook w-2/3 h-10 border border-gray rounded-md text-center"
                                                value={placaCarreta}
                                                placeholder="0"
                                                onChange={handleChangeCarreta}
                                                disabled={!isChecked} // Habilitar/deshabilitar el input basado en el estado del checkbox
                                            />
                                        </div>
                                    </div>
                                )}
    
                                {isChecked2 && (
                                    <div className="flex flex-col justify-between w-full gap-3 md:items-center md:flex-row">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Número Ensaque</p>
                                        </div>
                                        <div className="flex md:w-[50%] w-full justify-between">
                                            <input
                                                id="numeroEnsaque"
                                                className="text-gray p-2 md:text-[18px] text-[16px] focus:outline-none font-itcbook w-2/3 h-10 border border-gray rounded-md text-center"
                                                value={numeroEnsaque}
                                                placeholder="0"
                                                onChange={handleChangeEnsaque}
                                                disabled={!isChecked2} // Habilitar/deshabilitar el input basado en el estado del checkbox
                                            />
                                        </div>
                                    </div>
                                )}
    
                                {isChecked3 && (
                                    <div className="flex flex-col justify-between w-full gap-3 md:items-center md:flex-row">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">N° Contenedor</p>
                                        </div>
                                        <div className="flex w-[50%] gap-4">
                                            {/* Primer input (4 dígitos) */}
                                            <div className="flex w-[30%]">
                                                <input
                                                    id="numeroContenedor"
                                                    type="text"
                                                    className={`text-gray w-full p-2 md:text-[18px] text-[16px] focus:outline-none font-itcbook h-10 border rounded-md text-center ${estiloContenedor.numeroContenedor}`}
                                                    value={numeroContenedor}
                                                    placeholder="XXXX"
                                                    onChange={handleChangeContenedor}
                                                    disabled={!isChecked3}
                                                />
                                            </div>
    
                                            {/* Segundo input (6 dígitos) */}
                                            <div className="flex w-[50%]">
                                                <input
                                                    id="numeroContenedor2"
                                                    type="text"
                                                    className={`text-gray w-full p-2 md:text-[18px] text-[16px] focus:outline-none font-itcbook h-10 border rounded-md text-center ${estiloContenedor.numeroContenedor2}`}
                                                    value={numeroContenedor2}
                                                    placeholder="000000"
                                                    onChange={handleChangeContenedor2}
                                                    disabled={!isChecked3}
                                                />
                                            </div>
    
                                            {/* Tercer input (1 dígito) */}
                                            <div className="flex w-[20%]">
                                                <input
                                                    id="numeroContenedor3"
                                                    type="text"
                                                    className={`text-gray w-full p-2 md:text-[18px] text-[16px] focus:outline-none font-itcbook h-10 border rounded-md text-center ${estiloContenedor.numeroContenedor3}`}
                                                    value={numeroContenedor3}
                                                    placeholder="0"
                                                    onChange={handleChangeContenedor3}
                                                    disabled={!isChecked3}
                                                />
                                            </div>
                                        </div>
                                        
                                    </div>
                                )}
                                {isChecked4 && (
                                    <div className="flex flex-col justify-between w-full gap-3 md:items-center md:flex-row">
                                        <div className="w-[50%] justify-start">
                                            <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Guía de Remisión</p>
                                        </div>
                                        <div className="flex md:w-[50%] w-full justify-between">
                                            <input
                                                id="guiaRemision"
                                                type="text"
                                                className="text-gray p-2 md:text-[18px] text-[16px] focus:outline-none font-itcbook w-2/3 h-10 border border-gray rounded-md text-center"
                                                value={guiaRemision}
                                                placeholder="0"
                                                onChange={handleChangeGuia}
                                                disabled={!isChecked4} // Habilitar/deshabilitar el input basado en el estado del checkbox
                                            />
                                        </div>
                                    </div>
                                )}
    
                                <div className="flex flex-col justify-between w-full gap-3 md:items-center md:flex-row">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Observación</p>
                                    </div>
                                    <div className="md:w-[50%] w-full justify-start">
                                        <textarea
                                            id="observacion"
                                            className="text-gray p-2 md:text-[20px] text-[18px] focus:outline-none font-itcbook w-full h-28 border border-gray rounded-md"
                                            placeholder="Escribe una observación"
                                            value = {observation}
                                            onChange={(e) => setObservation(e.target.value)}
                                        />      
                                    </div>
                                </div>
                                {/* 
                                <div className="flex items-center justify-between w-full gap-3">
                                    <div className="w-[50%] justify-start">
                                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Cantidad de personas</p>
                                    </div>
                                    <div className="w-[50%] justify-start">
                                        <p className="text-gray md:text-[20px] text-base font-itcbook">10</p>
                                    </div>
                                </div>  
                                */}  
            
                                </>
                            ) : (
                                <p className="text-red">No hay datos disponibles.</p>
                            )}
                            </div>   
                        </div>

                        <button className="flex flex-col items-center justify-center pt-12"
                        onClick={handleSignatureClick} >
                            {/** MOSTRAR LA FIRMA GUARDADA COMO IMAGEN */}
                            <div className="w-[280px] h-[150px] ">
                                {signatureImage ? (
                                <img src={signatureImage} alt="Firma guardada" className="object-cover w-full h-full" />
                                ) : null}
                            </div>
                            <div className="w-[280px] bg-blue h-0.5 mb-2"></div> 
                            <div className="text-sm text-center font-itcbook text-gray">
                            {qrData?.nombre_conductor || visitaData?.driverName ?(
                                <>
                                    <p>{qrData?.nombre_conductor || visitaData?.driverName || "N/A"}</p>
                                    <p> {qrData?.dni || visitaData?.dni || "N/A"}</p>
                                    </>
                                ) : (
                                    <p className="text-red">No hay datos disponibles.</p>
                                )}
                            </div>
                        </button> 
                        {mostrarAlertas.signatureImage && (
                            <span className="mt-2 text-xl text-red-500">⚠️</span> // Ícono de alerta
                        )}
                        <ModalSignature showModalSignature={showModalSignature} closeModalSignature={closeModalSignature}  onSaveSignature={handleSaveSignature}/>      
    
                        <div className="flex w-full sm:px-[5%] justify-between pt-16 gap-2">
                            <button
                            onClick={handleSave}
                            className={`sm:px-24 px-[35px] inline-block bg-green sm:h-[64px] h-[46px] text-lg text-center text-white rounded-2xl font-itcdemi 
                                ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={!validarCamposObligatorios}
                            >
                                {loading ? 'Guardando...' : 'Guardar'}
                            </button> 
                            {isSalida ? (
                                <ModalRegister 
                                showModalRegister={showModalRegister}
                                closeModal={closeModal}
                                isSalida={isSalida}
                                onClose={handleRedirectToTicket}
                                /> 
                              )  :(
                               <ModalRegister 
                               showModalRegister={showModalRegister}
                                closeModal={closeModal} 
                                onClose={handleRedirectToTicket}
                                />  
                              )}
                        
                            <button className="sm:px-24 px-[35px] inline-block sm:h-[64px] h-[46px] text-lg text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                                Cancelar
                            </button>    
                        </div>   
                     </div>
                     <Programate/>
                </div>
            </div>
        </div>
    );
}
